import { render, staticRenderFns } from "./Alfakodo.vue?vue&type=template&id=e92e05ae"
import script from "./Alfakodo.vue?vue&type=script&lang=js"
export * from "./Alfakodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports